var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { get } from "lodash";
import Button from "@irati/ui/src/Button";
import { Body } from "@irati/ui/src/Typography";
import mfaService from "@irati/auth/services/mfa";
import GenericErrorCodes from "@irati/utils/services/errorCodes/Generic";
import Link from "@irati/ui/src/Link";
import FormattedMessage, { injectIntl } from "@irati/utils/lang";
import { mfaTracking } from "@irati-tracking/platform";
import { Modal } from "../BaseModal";
import { Screens } from "./index";
import { ButtonContainer } from "./styled";
var MFAPopupRequest = /** @class */ (function (_super) {
    __extends(MFAPopupRequest, _super);
    function MFAPopupRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            submit: null
        };
        _this.handleSuccess = function () {
            var submit = mfaService
                .request()
                .then(function (mfa) {
                var phoneNumber = mfa.phoneNumberLastDigits;
                _this.props.selectScreen(Screens.ENTER, { phoneNumber: phoneNumber });
                mfaTracking.popupRequestCode();
            })
                .catch(function (err) {
                var errorCode = getErrorCode(err);
                var codes = [GenericErrorCodes.PBAUTHMFAUserNotFound, GenericErrorCodes.PBMFASetupRequired];
                if (codes.includes(errorCode)) {
                    return _this.props.selectScreen(Screens.SETUP);
                }
                throw err;
            });
            _this.setState({ submit: submit });
        };
        _this.handleCancel = function () {
            _this.props.onCancel();
            mfaTracking.popupCancel();
        };
        return _this;
    }
    MFAPopupRequest.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.show === false && this.props.show === true) {
            mfaTracking.popupShown();
        }
    };
    MFAPopupRequest.prototype.render = function () {
        var _a = this.props, show = _a.show, formatMessage = _a.formatMessage;
        return (React.createElement(Modal, { show: show, header: "platform.mfa.request.title" },
            React.createElement(Body, null,
                React.createElement(FormattedMessage, { id: "platform.mfa.request.bodyWithUrl", values: {
                        url: (React.createElement(Link, { href: formatMessage({ id: "platform.mfa.request.href" }) },
                            React.createElement(FormattedMessage, { id: "platform.mfa.request.hrefText" })))
                    } })),
            React.createElement(ButtonContainer, null,
                React.createElement(Button, { tertiary: true, onClick: this.handleCancel, id: "mfa_request_buttonCancel", marginRight: 2 },
                    React.createElement(FormattedMessage, { id: "platform.mfa.request.cancel" })),
                React.createElement(Button, { onClick: this.handleSuccess, primary: true, load: this.state.submit },
                    React.createElement(FormattedMessage, { id: "platform.mfa.request.submit" })))));
    };
    return MFAPopupRequest;
}(PureComponent));
export default injectIntl(MFAPopupRequest);
function getErrorCode(data) {
    var apiCode = get(data, "extra.error.response.code");
    var graphCode = get(data, "extra.error.response.errors[0].errorCode");
    var apolloNetworkCode = get(data, "networkError.errorCode");
    return apiCode || graphCode || apolloNetworkCode;
}
